import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container'
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import HelpOutline from '@material-ui/icons/HelpOutline';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { useHistory } from 'react-router'

import parseISO from 'date-fns/parseISO'
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import format from 'date-fns/format';
import ja from 'date-fns/locale/ja';

import { useSnackbar } from 'notistack';
import useInfiniteScroll from 'react-infinite-scroll-hook';

import useAppBar from 'components/AppBar/useAppBar';
import useAuth from 'components/Auth/useAuth';
import useClient from 'components/Auth/useClient';
import useFunctions from 'components/Auth/useFunctions';
import useSharedDialog from 'components/SharedDialog/useSharedDialog';
import useStore from 'components/Store/useStore';

import SearchButton from './components/SearchButton';

// props.hiddenWhenでthemeによる条件をつけて非表示化できる簡易コンポーネントです
function TableCell2(props) {
  // hiddenWhenが指定されている時は、常に'false'＝非表示にしないようにします。
  const args = props.hiddenwhen || 'false';

  // 条件にmatchする時は非表示にするため、nullを返します。
  const matches = useMediaQuery(args);
  if (matches) return null;
  return <TableCell {...props} />
}

function ReportTitle(props) {
  const classes = useStyles();
  return <Typography className={classes.title} component="h2" variant="h6" gutterBottom {...props} />
}


/**
 * 受信トレイで取得対象とする帳票種別
 */
const InboxReportTarget = {
  /** 給与明細書 */
  Salary: 1,

  /** 給与明細書以外 */
  WithoutSalary: 2,
};

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  complete: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
  },
  spacing: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(3),
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    padding: theme.spacing(3),
  },
  bold: {
    fontWeight: 'bold'
  },
  answer: {
    marginLeft: theme.spacing(2)
  },
  paper: {
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
  },
  blur: {
    filter: 'blur(4px)'
  },
  seeMore: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    marginTop: theme.spacing(3),
  },
  title: {
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  naviee: {
    padding: theme.spacing(2),
    height: '200px',
  },
  columnDate: {
    width: "8em"
  },
  columnNo: {
    width: "9em"
  },
  columnCompany: {
    width: "30%"
  },
  columnToNow: {
    width: "6em"
  },
  columnButton: {
    width: "8em"
  },
  toNow: {
    "font-size": "smaller"
  },
  opened: {
  },
  notOpened: {
    "font-weight": "bold"
  },
}));

function LinkButton(props) {
  const
  {
    to
  } = props;

  const history = useHistory();

  const handleClick = React.useCallback(() => {
    history.push(to);
  }, [to, history]);

  return (
    <Button variant="contained" color="primary" onClick={handleClick}>
      開く
    </Button>);
}

function PaperLoaded(props) {

  const {
    loading,
    hasNextPage,
    sentryRef,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate} hiddenwhen={theme.breakpoints.down('xs')}>送付日</TableCell2>
            <TableCell2 className={classes.columnCompany} hiddenwhen={theme.breakpoints.down('xs')}>企業名</TableCell2>
            <TableCell2>ドキュメント</TableCell2>
            <TableCell2 className={classes.columnToNow}></TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{format(parseISO(row.receiveTimestamp), 'yyyy/MM/dd')}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties?.agencyName ?? row.customer}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.name}</TableCell2>
              <TableCell2 className={classes.toNow}>{formatDistanceToNow(parseISO(row.receiveTimestamp), {locale: ja})}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id} /></TableCell2>
            </TableRow>
          ))}
          {(loading || hasNextPage) && (
              <TableRow ref={sentryRef}>
                {
                  items.length > 0 ? <TableCell colSpan={5}><Typography align="center">さらに表示</Typography></TableCell> : null
                }
              </TableRow>
            )}
        </TableBody>
      </Table>
    </Paper>
  );
}

function PaperLoadedSalary(props) {

  const {
    loading,
    hasNextPage,
    sentryRef,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate} hiddenwhen={theme.breakpoints.down('xs')}>送付日</TableCell2>
            <TableCell2 className={classes.columnDate} hiddenwhen={theme.breakpoints.down('xs')}>支払日</TableCell2>
            <TableCell2 className={classes.columnDate} hiddenwhen={theme.breakpoints.down('xs')}>締日</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('sm')}>企業名</TableCell2>
            <TableCell2 className={classes.columnToNow}></TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{format(parseISO(row.receiveTimestamp), 'yyyy/MM/dd')}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties.paymentDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties.closeDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('sm')}>{row.properties?.agencyName ?? row.customer}</TableCell2>
              <TableCell2 className={classes.toNow}>{formatDistanceToNow(parseISO(row.receiveTimestamp), { locale: ja })}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id} /></TableCell2>
            </TableRow>
          ))}
          {(loading || hasNextPage) && (
            <TableRow ref={sentryRef}>
              {
                items.length > 0 ? <TableCell colSpan={5}><Typography align="center">さらに表示</Typography></TableCell> : null
              }
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}


function PaperBeforeLoading(props)
{
  const {
    sentryRef,
  } = props;

  const items = Array.apply(null, Array(5));
  const classes = useStyles();
  const theme = useTheme();

  return (
      <Paper className={classes.paper} ref={sentryRef}>
        <Table size="small" className={classes.blur}>
          <TableHead>
            <TableRow>
              <TableCell2 className={classes.columnDate} hiddenwhen={theme.breakpoints.down('xs')}>送付日</TableCell2>
              <TableCell2 className={classes.columnCompany} hiddenwhen={theme.breakpoints.down('xs')}>企業名</TableCell2>
              <TableCell2>ドキュメント</TableCell2>
              <TableCell2 className={classes.columnToNow}></TableCell2>
              <TableCell2 className={classes.columnButton}></TableCell2>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((row, index) => (
              <TableRow key={index}>
                <TableCell2 hiddenwhen={theme.breakpoints.down('xs')}>0000/00/00</TableCell2>
                <TableCell2 hiddenwhen={theme.breakpoints.down('xs')}>〇〇〇〇〇〇〇〇</TableCell2>
                <TableCell2>〇〇〇〇〇〇〇〇</TableCell2>
                <TableCell2 className={classes.toNow}>10秒前</TableCell2>
                <TableCell2><LinkButton disabled /></TableCell2>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
  );
}

function PaperBeforeLoadingSalary(props) {
  const {
    sentryRef,
  } = props;

  const items = Array.apply(null, Array(5));
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper} ref={sentryRef}>
      <Table size="small" className={classes.blur}>
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate} hiddenwhen={theme.breakpoints.down('xs')}>送付日</TableCell2>
            <TableCell2 className={classes.columnDate} hiddenwhen={theme.breakpoints.down('xs')}>支払日</TableCell2>
            <TableCell2 className={classes.columnDate} hiddenwhen={theme.breakpoints.down('xs')}>締日</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('sm')}>企業名</TableCell2>
            <TableCell2 className={classes.columnToNow}></TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row, index) => (
            <TableRow key={index}>
              <TableCell2 hiddenwhen={theme.breakpoints.down('xs')}>0000/00/00</TableCell2>
              <TableCell2 hiddenwhen={theme.breakpoints.down('xs')}>0000/00/00</TableCell2>
              <TableCell2 hiddenwhen={theme.breakpoints.down('xs')}>0000/00/00</TableCell2>
              <TableCell2 hiddenwhen={theme.breakpoints.down('sm')}>〇〇〇〇〇〇〇〇</TableCell2>
              <TableCell2 className={classes.toNow}>10秒前</TableCell2>
              <TableCell2><LinkButton disabled /></TableCell2>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function PaperEmpty(props)
{
  const classes = useStyles();
  const auth = useAuth();

  return (
    <Paper className={classes.empty}>
      <Typography>受信したドキュメントはありません</Typography>
      <Divider className={classes.spacing}/>
      <div style={{display: 'flex', alignItems: 'center', flexWrap: 'nowrap'}}>
        <HelpOutline color="primary" fontSize="large" /><Typography color="primary" variant="h5">ドキュメントが見れない場合</Typography>
      </div>
      <Box m={1}/>
      <Typography component="ul">
        <Typography component="li" className={classes.bold}>Naviドキュメントからメールを受け取っているのに受信トレイに表示されない</Typography>
        <Typography component="li" className={classes.bold} paragraph>ポップアップで「閲覧権限の無いドキュメントです」と表示される</Typography>
      </Typography>
      <div className={classes.answer}>
        <Typography>【メールを受信したアドレス】と【登録メールアドレス】が異なる可能性があります。</Typography>
        <Typography paragraph>メーリングリスト等でメールを受信した場合は、そのアドレスでの登録が必要です。</Typography>
        <Typography paragraph>登録メールアドレス：{auth.email}</Typography>
        <Typography>受信したメールをご確認お願いします。</Typography>
      </div>
    </Paper>
  );
}

function PaperComplete(props)
{
  const 
  {
    modeSearch,
    unread
  } = props;

  const classes = useStyles();
  const auth = useAuth();

  if (unread) {
    return (
      <Paper className={classes.complete}>
        <Typography>未読はありません</Typography>
      </Paper>
    );
  }

  if (modeSearch) {
    return (
      <Paper className={classes.complete}>
        <Typography>条件に該当するドキュメントはありません</Typography>
      </Paper>
    );
  }

  // ※ここに来ることはないはずだが、なんらかの理由でviewReportsのみデータが存在する場合にそなえて
  // すべて、で、ドキュメントが存在しない場合はエラー表示する
  return (
    <PaperEmpty />
  );
}

function InboxBase(props)
{
  const {
    unread,
    reportTarget,
  } = props;

  const [reports, setReports] = React.useState([]);
  
  const auth = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const client = useClient();
  const functions = useFunctions();

  const [loading, setLoading] = React.useState(false);
  const [hasNextPage, setHasNextPage] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [beforeLoading, setBeforeLoading] = React.useState(true);

  const loadMore = async function() {
    if (!auth.isValid) return;

    setLoading(true);
    try {
      await client.post('api/document/inbox', { unread, reportTarget, skip: reports.length })
      .then((response) => {
        setReports([...reports, ...response.data.reports]);
        setHasNextPage(response.data.hasNextPage);
      })
      .catch((error) => {
        setError(true);
        if (auth.expired() || error.response?.status == 401) {
          // トークンが期限切れの場合
          enqueueSnackbar('トークンの有効期限が切れたため、検索できませんでした。\nログインしなおしてください。', { whiteSpace: 'pre-line', variant: 'error' });
          functions.signOut();
        }
        else {
          // それ以外の場合
          enqueueSnackbar('データの取得に失敗しました。', { variant: 'error' });
        } 
      });
    }
    finally {
      setLoading(false);
      setBeforeLoading(false);
    }
  };

  const classes = useStyles();
  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore : loadMore,
    error,
  });

  return (
    beforeLoading ?

    reportTarget === InboxReportTarget.Salary ?
      <PaperBeforeLoadingSalary sentryRef={sentryRef} /> :
      <PaperBeforeLoading sentryRef={sentryRef} /> :

    reports.length > 0 ?

    reportTarget === InboxReportTarget.Salary ?
        <PaperLoadedSalary items={reports} loading={loading} hasNextPage={hasNextPage} sentryRef={sentryRef} /> : 
        <PaperLoaded items={reports} loading={loading} hasNextPage={hasNextPage} sentryRef={sentryRef} /> :
      <PaperComplete {...props} />
  );
}

function InboxUnread(props)
{
  return <InboxBase unread={true} {...props} />;
}

function InboxAll(props)
{
  return <InboxBase unread={false} {...props} />;
}

function InboxSalary(props) {
  return <InboxBase unread={false} reportTarget={InboxReportTarget.Salary}  {...props} />;
}

function InboxContract(props) {
  return <InboxBase unread={false} reportTarget={InboxReportTarget.WithoutSalary} {...props} />;
}



// 不明なレポート
function ReportError(props) {
  const {
    report,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper}>
      <ReportTitle>
        {report}
      </ReportTitle>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate}>送付日</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('xs')}>企業名</TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.sendDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties.agencyName}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id} /></TableCell2>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function ReportDispatchNotice(props) {
  const {
    report,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper}>
      <ReportTitle>
        {report}
      </ReportTitle>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate}>送付日</TableCell2>
            <TableCell2 className={classes.columnNo}>No.</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('xs')}>企業名</TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.sendDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.properties.orderNo}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties.agencyName}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id} /></TableCell2>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function ReportClientMng(props) {
  const {
    report,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper}>
      <ReportTitle>
        {report}
      </ReportTitle>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate}>送付日</TableCell2>
            <TableCell2 className={classes.columnNo}>No.</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('xs')}>企業名</TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.sendDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.properties.orderNo}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties.agencyName}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id}/></TableCell2>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function ReportBill(props) {
  const {
    report,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  const formatter = new Intl.NumberFormat('ja-JP');

  return (
    <Paper className={classes.paper}>
      <ReportTitle>
        {report}
      </ReportTitle>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate}>送付日</TableCell2>
            <TableCell2 className={classes.columnNo}>No.</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('xs')}>企業名</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('sm')} style={{ width: "10em" }}>締日</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('sm')} style={{ width: "10em" }}>金額</TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.sendDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.properties.billNo}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties.agencyName}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('sm')}>{row.properties.closeDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('sm')} style={{ textAlign: "right" }}>￥{formatter.format(row.properties.money)}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id} /></TableCell2>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function ReportSalary(props) {
  const {
    report,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper}>
      <ReportTitle>
        {report}
      </ReportTitle>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate}>送付日</TableCell2>
            <TableCell2 className={classes.columnDate}>支払日</TableCell2>
            <TableCell2 className={classes.columnDate}>締日</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('sm')}>企業名</TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.sendDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.properties.paymentDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.properties.closeDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('sm')}>{row.properties.agencyName}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id} /></TableCell2>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function ReportDispatchContract(props) {
  const {
    report,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper}>
      <ReportTitle>
        {report}
      </ReportTitle>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate}>送付日</TableCell2>
            <TableCell2 className={classes.columnNo}>No.</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('md')}>企業名</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('sm')} width="25%">ドキュメント名</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('xs')} width="25%">契約期間</TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.sendDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.properties.orderNo}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties.agencyName}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('sm')}>{row.name}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('md')}>{row.properties.term}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id}></LinkButton></TableCell2>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function ReportEmploymentContract(props) {
  const {
    report,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper}>
      <ReportTitle>
        {report}
      </ReportTitle>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate}>送付日</TableCell2>
            <TableCell2 className={classes.columnNo}>No.</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('md')}>企業名</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('xs')} width="25%">就業先</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('sm')} width="30%">契約期間</TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.sendDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.properties.orderNo}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties.agencyName}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('sm')}>{row.properties.clientName}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('md')}>{row.properties.term}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id}/></TableCell2>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

function ReportConflictDateNotice(props) {
  const {
    report,
    items
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  return (
    <Paper className={classes.paper}>
      <ReportTitle>
        {report}
      </ReportTitle>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell2 className={classes.columnDate}>送付日</TableCell2>
            <TableCell2 className={classes.columnNo}>No.</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('sm')}>企業名</TableCell2>
            <TableCell2 hiddenwhen={theme.breakpoints.down('xs')} style={{ width: "15em" }}>抵触日</TableCell2>
            <TableCell2 className={classes.columnButton}></TableCell2>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row.id}>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.sendDate}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened}>{row.properties.orderNo}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('xs')}>{row.properties.agencyName}</TableCell2>
              <TableCell2 className={row.isOpened ? classes.opened : classes.notOpened} hiddenwhen={theme.breakpoints.down('sm')}>{row.properties.conflictDate}</TableCell2>
              <TableCell2><LinkButton to={"/view/" + row.id}/></TableCell2>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export function DocumentSearch(props)
{
  const [store, setStore] = useStore();
   
  // 検索条件が変更された場合、再検索して表示する
  const auth = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const client = useClient();

  React.useEffect(() => {
    if (!auth.isValid) return;

    client.post('api/document/search', store.criteria)
      .then((response) => {

        setStore({ ...store, reports: response.data.reports });
      })
      .catch((error) => {
        if (auth.expired() || error.response.status == 401) {
          // トークンが期限切れの場合
          enqueueSnackbar('１２０分が経過したため、検索できませんでした。\nメールの受信から再度実行してください。', { whiteSpace: 'pre-line', variant: 'error' });
        }
        else {
          // それ以外の場合
          enqueueSnackbar('検索の実行に失敗しました。', { variant: 'error' });
        }
      });
  }, [client, auth, store.criteria]);

  const classes = useStyles();
  const reports = store.reports;

  return (
    <Container className={classes.container}>
      <Grid item xs={12}>
        {
          reports ? 
            reports.length == 0 ?
              <PaperComplete modeSearch /> :
              reports.map(item => {
              switch(item.report)
              {
                case "請求書":
                  return <ReportBill key={item.report} {...item} />;
                case "給与明細書":
                  return (<ReportSalary key={item.report} {...item} />);
                case "個別契約書":
                  return (<ReportDispatchContract key={item.report} {...item} />);
                case "派遣通知書":
                  return (<ReportDispatchNotice key={item.report} {...item} />);
                case "派遣先管理台帳" :
                  return (<ReportClientMng key={item.report} {...item} />);
                case "抵触日通知書":
                  return (<ReportConflictDateNotice key={item.report} {...item} />);
                case "雇用契約書/就業条件明示書":
                case "雇用契約書":
                case "就業条件明示書":
                case "雇用契約書（兼）就業条件明示書":
                  return (<ReportEmploymentContract key={item.report} {...item} />);
                default:
                  return (<ReportError key={item.report} {...item} />);
              }
            }) : null
        }
      </Grid>
    </Container>
  );
}

export default function Inbox(props)
{
  // 検索ボタンのコールバック作成
  const [store, setStore] = useStore();
  const [initialized, setInitialized] = React.useState(false);
  const [empty, setEmpty] = React.useState(false);
  
  const setCriteria = React.useCallback((criteria) => {
    setStore({
      ...store, criteria, search: true
    })
  }, [store]);
  
  const sharedDialog = useSharedDialog();
  const handleSearch = React.useCallback(() => {
    const searchDialog = sharedDialog("search");
    searchDialog.open({ criteria: store.criteria, setCriteria, viewableReports: store.viewableReports });
  }, [store.criteria, setCriteria, sharedDialog]);

  const handleChange = (event, newValue) => {
    setStore(
      { ...store, tab: newValue }
    );
  };

  React.useEffect(() => {
    if (store.viewableReports) {
      setInitialized(true);
    }
    setEmpty(store.viewableReports?.length == 0);
  }, [store]);

  const downXs = useMediaQuery(theme => theme.breakpoints.down("xs"));  
  useAppBar('受信トレイ', [SearchButton({ onClick: handleSearch, disabled: empty, fixed: downXs.toString() })]);

  const classes = useStyles();
  return (
    <Container className={classes.container}>
      {
        initialized ?
        empty ? <PaperEmpty /> :
        store.search ? <DocumentSearch /> :

        store.viewableReports.includes(2) ?

          // 閲覧可能な給与明細書がある場合のタブ構成（発行済みの給与明細書がある派遣スタッフ用）
          (<React.Fragment>
            <Tabs value={store.tab ?? 0} onChange={handleChange} indicatorColor='primary'>
              <Tab label="未読" />
              <Tab label="給与明細書" />
              <Tab label="契約書" />
            </Tabs>
            <Box sx={{ m: 1 }} />
            <Grid item xs={12}>
              {store.tab == 0 ? <InboxUnread /> :
                store.tab == 1 ? <InboxSalary /> : <InboxContract />}
            </Grid>
          </React.Fragment>) :

          // 閲覧可能な給与明細書が「ない」場合のタブ構成（上記以外）
          (<React.Fragment>
            <Tabs value={store.tab ?? 0} onChange={handleChange} indicatorColor='primary'>
              <Tab label="未読" />
              <Tab label="すべて" />
            </Tabs>
            <Box sx={{ m: 1 }} />
            <Grid item xs={12}>
              {store.tab == 0 ? <InboxUnread /> : <InboxAll />}
            </Grid>
          </React.Fragment>) :

          <div />
      }
    </Container>
  );
}